function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M31.41.49c-9.312 14.188-7.93 25.6 1.413 50.096 1.784 4.68 3.255 8.809 4.4 12.522m2.1 8.103c1.936 9.798.587 16.554-4.447 24.299M54.872.49c-8.852 13.488-8.04 24.466.088 46.562m2.749 7.336c7.454 20.313 8.099 29.629.629 41.122M77.16.49c-6.5 9.905-7.79 18.456-4.797 31.051m2.246 7.911c1.096 3.402 2.421 7.09 3.964 11.134 8.77 22.998 9.974 32.736 2.053 44.924"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M111.536 84.996c-11.18 0-11.205-5.996-22.444-5.996-11.24 0-11.214 5.996-22.428 5.996S55.467 79 44.27 79c-10.455 0-11.162 5.228-20.34 5.92-.65.05-12.148 10.8-12.148 10.8v13.497h99.775s.329-24.221-.021-24.221z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M.771 96.097L99.148 7.253M5.18 101.803l98.377-88.843"
}));

function SvgRoomNoHotWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 110,
    viewBox: "0 0 112 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomNoHotWater);
export default __webpack_public_path__ + "static/media/RoomNoHotWater.cd7f2058.svg";
export { ForwardRef as ReactComponent };